import React from 'react'
import Layout from '../../components/layout/Layout'
import OrdersTable from '../../elements/tables/orders/OrdersTable'

export default function Orders() {
  return (
    <div>
      <Layout>
        <OrdersTable />
      </Layout>
    </div>
  )
}
